(function () {
  var selector = 'script.y-rich-snippet-script[type="application/ld+json"]';

  function removeTargets(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(selector);
    if (!nodes || !nodes.length) return;
    console.log(111111, nodes);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      try {
        n.remove();
      } catch (e) {
        if (n.parentNode) n.parentNode.removeChild(n);
      }
    }
  }

  removeTargets(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      removeTargets(document);
    });
  } else {
    removeTargets(document);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var mutation = mutations[m];
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue; // only element nodes
        if (node.matches && node.matches(selector)) {
          console.log(22222, node);
          try {
            node.remove();
          } catch (e) {
            if (node.parentNode) node.parentNode.removeChild(node);
          }
          continue;
        }
        removeTargets(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();